import { PageDto } from '@asset-metrix/portal-gateway-client-js';

import { FilterConfigDto } from '../store/states/filterTypes';

export function getGlobalSearchFiltersFromPage(
  page: PageDto
): { widgetId: string; metadataId: string }[] {
  return recursivelyGetFilters(page.contents);
}

function recursivelyGetFilters(
  contents: PageDto['contents']
): { widgetId: string; metadataId: string }[] {
  const ret: { widgetId: string; metadataId: string }[] = [];
  return contents.reduce((acc, content) => {
    if (
      content.type === 'singleColumnGroup' ||
      content.type === 'twoColumnGroup'
    ) {
      return [...acc, ...recursivelyGetFilters(content.contents)];
    }
    if (content.type === 'widget' && content.entity.type === 'table') {
      const metadataIds: { widgetId: string; metadataId: string }[] =
        content.entity.config.filters
          ?.filter((f) => f.type === 'text' && f.isGlobalSearchFilter)
          .map((f: FilterConfigDto) => ({
            widgetId: content.id,
            metadataId: f.key,
          })) ?? [];
      return [...acc, ...metadataIds];
    }
    return acc;
  }, ret);
}
